export interface PrecioProveedor {
  id: number;
  idProveedor: number;
  idPresentacion: number;
  idCalibre: number;
  tipoProceso: string;
  tipoOperacion: string;
  precioMateriaPrima: number;
  precioServicio: number;
  fechaActualizacion: string;
  activo: boolean;
  presentacion?: {
    idPresentacion: number;
    descripcion: string;
  };
  calibre?: {
    idCalibre: number;
    descripcion: string;
  };
}

export interface PrecioProveedorState {
  precios: PrecioProveedor[];
  loading: boolean;
  error: string | null;
}

export interface SaveBulkRequest {
  idProveedor: number;
  tipoProceso: string;
  tipoOperacion: string;
  precios: PrecioProveedor[];
}

export const TIPOS_PROCESO = ['INTERNO', 'EXTERNO'] as const;

export const TIPOS_OPERACION: Record<string, string[]> = {
  'INTERNO': ['COMPRA', 'PROD_B_MALLAS', 'REPROCESO', 'SERVICIO'],
  'EXTERNO': ['PROD_B_KILOS', 'OTRA_PLANTA'],
};

export const tipoOperacionLabels: Record<string, string> = {
  'COMPRA': 'Compra',
  'PROD_B_MALLAS': 'Prod. B Mallas/Entero',
  'REPROCESO': 'Reproceso',
  'SERVICIO': 'Servicio',
  'PROD_B_KILOS': 'Prod. B Kilos',
  'OTRA_PLANTA': 'Otra Planta',
};
